var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "chevronUp",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.075 7.3748L0 6.2998L6 0.299805L12 6.2748L10.925 7.3498L6 2.4248L1.075 7.3748Z",
    fill: "white"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1903_24180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.1125L21.25 12.7375V22.5H18.75V15H11.25V22.5H8.75V12.7375L15 7.1125ZM15 3.75L2.5 15H6.25V25H13.75V17.5H16.25V25H23.75V15H27.5L15 3.75Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1903_24180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "id",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1903_24169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4H25.5C26.9569 4 28.125 5.16812 28.125 6.625V22.375C28.125 23.8319 26.9569 25 25.5 25H4.5C3.04312 25 1.875 23.8319 1.875 22.375L1.88812 6.625C1.88812 5.16812 3.04312 4 4.5 4ZM4.5 22.375H25.5V14.5V9.25V6.625H4.5V9.25V14.5V22.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.53906C15.8465 9.53906 16.5391 10.2316 16.5391 11.0781C16.5391 11.9246 15.8465 12.6172 15 12.6172C14.1535 12.6172 13.4609 11.9246 13.4609 11.0781C13.4609 10.2316 14.1535 9.53906 15 9.53906ZM15 16.4648C17.0777 16.4648 19.4633 17.4575 19.6172 18.0039V18.7734H10.3828V18.0116C10.5367 17.4575 12.9223 16.4648 15 16.4648ZM15 8C13.2993 8 11.9219 9.37746 11.9219 11.0781C11.9219 12.7788 13.2993 14.1562 15 14.1562C16.7007 14.1562 18.0781 12.7788 18.0781 11.0781C18.0781 9.37746 16.7007 8 15 8ZM15 14.9258C12.9454 14.9258 8.84375 15.957 8.84375 18.0039V20.3125H21.1562V18.0039C21.1562 15.957 17.0546 14.9258 15 14.9258Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1903_24169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "venues",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1903_24173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 3.75H23.75V1.25H21.25V3.75H8.75V1.25H6.25V3.75H5C3.625 3.75 2.5 4.875 2.5 6.25V26.25C2.5 27.625 3.625 28.75 5 28.75H25C26.375 28.75 27.5 27.625 27.5 26.25V6.25C27.5 4.875 26.375 3.75 25 3.75ZM25 26.25H5V12.5H25V26.25ZM25 10H5V6.25H25V10Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1903_24173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "concierge",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1903_24176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17.5V22.5H21.25V17.5H23.75ZM8.75 17.5V22.5H7.5C6.8125 22.5 6.25 21.9375 6.25 21.25V17.5H8.75ZM15 1.25C8.7875 1.25 3.75 6.2875 3.75 12.5V21.25C3.75 23.325 5.425 25 7.5 25H11.25V15H6.25V12.5C6.25 7.6625 10.1625 3.75 15 3.75C19.8375 3.75 23.75 7.6625 23.75 12.5V15H18.75V25H23.75V26.25H15V28.75H22.5C24.575 28.75 26.25 27.075 26.25 25V12.5C26.25 6.2875 21.2125 1.25 15 1.25Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1903_24176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "notification",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.9 20 8 20ZM14 14V9C14 5.93 12.37 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.64 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14ZM12 15H4V9C4 6.52 5.51 4.5 8 4.5C10.49 4.5 12 6.52 12 9V15Z",
    fill: "white"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "info",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 6.0625L5.58642 6.05083C5.66122 6.01346 5.74516 5.99831 5.8283 6.00717C5.91145 6.01604 5.99031 6.04854 6.05556 6.10083C6.1208 6.15313 6.1697 6.22302 6.19645 6.30224C6.2232 6.38146 6.22669 6.46669 6.2065 6.54783L5.7935 8.20217C5.77317 8.28335 5.77655 8.36866 5.80324 8.44798C5.82993 8.5273 5.87881 8.5973 5.94408 8.64968C6.00935 8.70206 6.08828 8.73461 6.1715 8.74349C6.25471 8.75236 6.33873 8.73718 6.41358 8.69975L6.4375 8.6875M11.25 6.5C11.25 7.18944 11.1142 7.87213 10.8504 8.50909C10.5865 9.14605 10.1998 9.7248 9.71231 10.2123C9.2248 10.6998 8.64605 11.0865 8.00909 11.3504C7.37213 11.6142 6.68944 11.75 6 11.75C5.31056 11.75 4.62787 11.6142 3.99091 11.3504C3.35395 11.0865 2.7752 10.6998 2.28769 10.2123C1.80018 9.7248 1.41347 9.14605 1.14963 8.50909C0.885795 7.87213 0.75 7.18944 0.75 6.5C0.75 5.10761 1.30312 3.77226 2.28769 2.78769C3.27226 1.80312 4.60761 1.25 6 1.25C7.39239 1.25 8.72774 1.80312 9.71231 2.78769C10.6969 3.77226 11.25 5.10761 11.25 6.5ZM6 4.3125H6.00467V4.31717H6V4.3125Z",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.29ab445efbf7d44f8c08fcff152dc9e8.svg";
export { ForwardRef as ReactComponent };